export default __webpack_public_path__ + "static/media/print-mobile-4.7189d1e2.png";